export default (function (value) {
  return value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isUndefined.js
// module id = 2763
// module chunks = 0